/**
 * @file Route: signup
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import Header from "components/Header/Pro";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormRegister } from "components/Form/Register";
import "./index.scss";

console.log("Route signup/index.js mounted.");

Header();
replaceFragment("registerForm", "components.FormRegister").then(() => FormRegister());

